import React from 'react';
import StatsPanel from '../components/AdminPanel/StatsPanel';
import ExpiredSessionModal from '../components/Expired/ExpiredSessionModal';
import { useSessionExpiration } from '../hooks/useSessionExpiration';

const AdminPage: React.FC = () => {
    const { isSessionExpired, setIsSessionExpired } = useSessionExpiration();



    return (
        <div className="flex-1 p-6 bg-white dark:bg-[#0b0614] text-gray-900 dark:text-gray-100 min-h-screen transition-colors duration-300">
            <ExpiredSessionModal
                isOpen={isSessionExpired}
                onClose={() => {
                    setIsSessionExpired(false);
                    window.location.href = '/login';
                }}
            />
            <div className="max-w-7xl mx-auto">
                <StatsPanel />
            </div>
        </div>
    );
};

export default AdminPage;